import { render, staticRenderFns } from "./GadgetApprovals.vue?vue&type=template&id=166034c4"
import script from "./GadgetApprovals.vue?vue&type=script&lang=js"
export * from "./GadgetApprovals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports